import React from "react";
import { Box, Typography } from "@mui/material";

export interface SectionHeaderProps {
  title: string;
  icon?: React.ReactNode;
  help?: string;
}

/**
 * Section header used at the top of form cards.
 * Title + optional leading icon + optional contextual help tooltip.
 */
export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  icon,
}) => (
  <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
    {icon && (
      <Box sx={{ mr: 1, display: "flex", color: "primary.main" }}>{icon}</Box>
    )}
    <Typography variant="h6" sx={{ fontWeight: 600, flex: 1 }}>
      {title}
    </Typography>
  </Box>
);

export default SectionHeader;
